module.exports = __webpack_public_path__ + "img/status_badge_bullet_in_progress.a88789c2.svg";